import { Paper, Stack, Typography } from "@mui/material";
import { useResponsive } from "@/hooks";
import Logo from "@/assets/logos/bitelink-logo-blue-bg.svg";
import SignUpForm from "./SignUpForm";

const SignUp = () => {
  const { isMobile, isTablet } = useResponsive();

  return (
    <Stack direction={{ xs: "column", lg: "row" }} minHeight="100vh">
      <Stack
        flex={{ lg: 3 }}
        alignItems="center"
        justifyContent="center"
        paddingY={6}
        paddingX={2}
        paddingBottom={"200px"}
        spacing={3}
        sx={{
          background: "linear-gradient(139deg, #015FEE 42.76%, #D0F857 94.31%)",
        }}
      >
        <img src={Logo} alt="Bitelink logo" style={{ cursor: "pointer" }} onClick={() => (window.location.href = "https://bitelink.website")} />
        <Paper
          sx={{
            minWidth: isMobile ? "auto" : 350,
            padding: isMobile ? 3 : 6,
            borderRadius: 6,
            zIndex: 1,
          }}
        >
          <SignUpForm />
        </Paper>
        <Typography variant="body2" color="white">
          Ya tienes una cuenta?{" "}
          <a href="/login" style={{ color: "white" }}>
            Iniciar Sesión
          </a>
        </Typography>
      </Stack>

      <Stack
        flex={{ xs: 1 }}
        sx={{
          background: "white",
        }}
        justifyContent={{ lg: "flex-end" }}
        alignItems={"flex-start"}
      >
        <img
          src="https://firebasestorage.googleapis.com/v0/b/menuapp-b44a8.appspot.com/o/assets%2Fsign-up-bl.png?alt=media&token=1bc51498-57c1-4910-8f0f-4564e2b265a3"
          alt="sign up platform illustration"
          style={{
            width: isMobile ? "80%" : "700px",
            marginLeft: isMobile || isTablet ? "auto" : "-300px",
            marginRight: "auto",
            marginTop: isMobile || isTablet ? "-175px" : 0,
          }}
        />
      </Stack>
    </Stack>
  );
};

export default SignUp;
